export let februaryAbbreviatedLowercase = "EACPMc";
export default {februaryAbbreviatedLowercase};